<script lang="ts">
    //import {ASSET_URL} from "../config";

    import {myStore} from "../../stores.js";

    export let title = "Person";
    export let index:number;
    //export let required = true;
    export let formGroupName:string;

    console.log("formGroupName = ", formGroupName);


</script>

<div class="contact-person-box">

    <div class="box-header">
        <h4>{title}</h4>
    </div>
    <div class="box-content">
        <div class="custom-row">
            <div class="custom-col-5 mb-3"> <!--{$myStore.errors.step1[formGroupName]?.firstname}-->
                <input class="w-100" class:error={$myStore.errors.step1[formGroupName]?.firstname} type="text" name="step1.{formGroupName}.firstname" placeholder="Prénom"/>
            </div>
            <div class="custom-col-7 mb-3">
                <input class="w-100" class:error={$myStore.errors.step1[formGroupName]?.lastname} type="text" name="step1.{formGroupName}.lastname" placeholder="Nom"/>
            </div>
        </div>
        <div class="custom-row">
            <div class="custom-col-12 mb-3">
                <input class="w-100" type="text" name="step1.{formGroupName}.position" placeholder="Fonction" class:error={$myStore.errors.step1[formGroupName]?.position}/>
            </div>
            <div class="custom-col-12 mb-3">
                <input class="w-100" type="text" name="step1.{formGroupName}.address" placeholder="Addresse" class:error={$myStore.errors.step1[formGroupName]?.address}/>
            </div>
            <div class="custom-col-12 mb-3">
                <input class="w-100" type="email" name="step1.{formGroupName}.email" placeholder="E-Mail" class:error={$myStore.errors.step1[formGroupName]?.email}/>
            </div>
            <div class="custom-col-12 mb-3">
                <input class="w-100" type="text" name="step1.{formGroupName}.phone" placeholder="Téléphone" class:error={$myStore.errors.step1[formGroupName]?.phone}/>
            </div>
        </div>

    </div>

</div>


<style lang="scss">

  .contact-person-box {

    background: $secondary-color;
    padding: 1.5rem;
    border-radius: 9px;
    color: #F8F7F7;
    max-width: 600px;
    min-width: 298px;
    flex: 1;


    .box-header {

      h4 {
        margin: 0;
        padding: 0;

      }

      margin-bottom: 1rem;

    }
  }


</style>
